

export enum SearchType {
	CONTAINS = "CONTAINS",
	EXACT_MATCH = "EXACT_MATCH",
	RANGE = "RANGE",
	PREFIX_MATCH = "PREFIX_MATCH",
	NESTED = "NESTED",
	NOT_MATCH = "NOT_MATCH",
	TERMS = "TERMS"
}

export interface SearchValue {
	dataType: string,
	value?: string,
	valueList?: string[],
	rangeValue?: RangeValue
}

export interface RangeValue {
	inclusiveStartValue: number,
	inclusiveEndValue: number
}


export interface  Query {
	andQuery?: Query[],
	orQuery?: Query[],
	comparatorQuery?: ComparatorQuery
}

export interface  ComparatorQuery {
	field: String,
	comparator: SearchType,
	value: SearchValue
}


export enum InventoryType {
	ON_HAND = "ON_HAND",
	IMPENDING = "IMPENDING",
	QUARANTINED = "QUARANTINED",
	FORECASTED = "FORECASTED"
}

export interface QuantityMap{
	TOTAL_QUANTITY: number,
	ALLOCATED_QUANTITY: number,
	AVAILABLE_QUANTITY: number
}

export interface GlobalFungibleMap {
	CPG: string
}

export interface ExternalReferenceIds{
	type: ExternalReferenceIdType,
	value: string
}
export enum ExternalReferenceIdType {
	PO_NUMBER = "PO_NUMBER",
	RequestId = 'RequestId',
	SHIPMENT_ID = 'SHIPMENT_ID',
	ASN_ID = 'ASN_ID',
	SERIAL_NUMBER = 'SERIAL_NUMBER',
	MATERIAL_SUBLOT_ID = 'MATERIAL_SUBLOT_ID',
	ASSOCIATED_DEMAND_ID = 'ASSOCIATED_DEMAND_ID',
	DESTINATION_LOCATION_ID = 'DESTINATION_LOCATION_ID',
	RESERVATION_ID = 'RESERVATION_ID',
	GAT_ALLOCATION_ID = 'GAT_ALLOCATION_ID',
	SUPPLIER_ID = 'SUPPLIER_ID',
	SUPPLIER_CODE = 'SUPPLIER_CODE',
	ODM_CODE = 'ODM_CODE'
}

export interface DateIdentifiers{
	type: DateIdentifierType,
	value: string
}

enum DateIdentifierType {
	RECEIVE_DATE = "RECEIVE_DATE",
	ON_HOLD_DATE = "ON_HOLD_DATE",
	AVAILABILITY_DATE = "AVAILABILITY_DATE"
}
export interface IP_InventoryProjectionSortCriterion {
	field: String,
	order: IP_SortOrder
}

export enum IP_SortOrder {
	ASC = "ASC",
	DESC = "DESC"
}

export enum PaginationType {
	OFFSET_BASED = "OFFSET_BASED"
}


export enum LocalStorageItem {
	LOCATION_TYPE = "uipLocationType",
	SITE_NAME = "uipSiteName",
	PROJECT_TAG = "uipProjectTag",
	IPN = "uipIPN",
	ITEM_CATEGORY = "uipItemCategory",
	ASSET_ID = "uipAssetID",
	BUSINESS_PROGRAM = "uipBusinessProgram",
	FINANCIAL_OWNERSHIP = "uipFinancialOwnership"
}

export interface selectOptions {
    label: string | undefined ;
    value: string | undefined ;
}

export interface selectOptionsLocationNames {
	label: string | undefined ;
	options: selectOptions[] | undefined | any;
}

export interface selectOptionsSingleSelectLocationNames{
	label: string | undefined ;
	value: string | undefined ;
}

export interface defaultSearchParams {
    selectedLocationType: selectOptions[] | undefined | any;
    selectedSiteName: selectOptions[] | undefined | any;
    selectedProjectName: selectOptions[] | undefined | any;
    selectedIPN: selectOptions[] | undefined | any;
    selectedItemCategory: selectOptions[] | undefined | any;
	selectedAssetID: selectOptions[] | undefined | any;
	selectedBusinessProgram: selectOptions[] | undefined | any;
	selectedFinancialOwnership: selectOptions[] | undefined | any;
}

export interface FileLocationType{
	bucketName: string,
	key: string
}
export interface FileMetadata {
	requester: string,
	uploadedTimeStamp: number,
	fileName: string
}

export interface InventoryGraphVisualisationRequest {
	searchCriteria? : Query,
	rangeCriteria? : IP_RangeCriterion,
	aggregationCriteria? : IP_AggregationCriterion
}

export interface InventoryTrendsVisualisationRequest {
	searchCriteria? : Query,
	rangeCriteria? : IP_RangeCriterion,
	aggregationCriteria? : IP_AggregationCriterion
}
export interface InventoryTrendsVisualisationResponse {
	data : TrendsData[]
}
export interface TrendsData {
	type: string,
	views: TrendsEntity
}

interface TrendsEntity {
	name: string,
	values: DataEntity
}

interface DataEntity {
	x: string,
	y: number
}

export interface InventoryOverviewResponse {
	inventoryOverview: IP_Attributes[],
	inventoryMetrics: IP_Attributes[]
}

export interface InventoryOverviewRequest {
	searchCriteria? : Query,
	rangeCriteria? : IP_RangeCriterion
}

export interface IP_RangeCriterion {
	from: number,
	to: number,
	timeInterval: IP_TimeInterval
}

export interface IP_AggregationCriterion{
	name?: string,
	typeCriteria?: IP_TypeCriterion,
	aggregation?: IP_AggregationCriterion,
	aggregationCriteriaList?: IP_AggregationCriterion[]
}

export interface IP_TypeCriterion {
	type?: IP_AggregationOperationCriteria,
	field?: string,
	size?: number,
	order?: IP_SortOrder,
	afterKey?: string
}

export interface IP_AggregationOperationCriteria {
	operation?: IP_AggregationOperation
	subOperation?: IP_AggregationSubOperation
}

export enum IP_AggregationOperation {
	TERMS = "TERMS",
	PERCENTILES = "PERCENTILES",
	SUM = "SUM",
	AVERAGE = "AVERAGE",
	DATE_HISTOGRAM = "DATE_HISTOGRAM",
	BUCKET_SORT = "BUCKET_SORT",
	COMPOSITE = "COMPOSITE"
}

export enum IP_AggregationSubOperation {
	P50 = "P50",
	P90 = "P90",
	TERMS = "TERMS"
}

export enum IP_TimeInterval {
	DEFAULT = "DEFAULT",
	DAY = "DAY",
	WEEK = "WEEK",
	MONTH = "MONTH"
}

export enum UnifiedInventoryPortalViewType {
	GLOBAL_FUNGIBILITY = "GLOBAL_FUNGIBILITY"
}

export interface InventoryGraphVisualisationResponse{
	data: GraphDataType[]
}

export interface GraphDataType {
	type: string
	views: IP_Attributes[]
}

export interface IP_Attributes{
	key: string,
	value: string,
	subAttribute: IP_Attributes
}

export interface ItemCategoryType {
	type?: ItemCategoryTypeEnum,
	value?: string
}

export enum ItemCategoryTypeEnum {
	AGILE_CATEGORY = "AGILE_CATEGORY",
	INTERNAL_RACK_TYPE = "AGILE_CATEGORY",
	EXTERNAL_RACK_TYPE = "AGILE_CATEGORY"
}